<template>
  <div class="beneficiary-pending-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><svg-icon icon-class="firewall" /> Beneficiary Pending</span>
      </div>

      <div>
        <data-tables
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
          size="mini"
          :page-size="20"
          :pagination-props="{
            background: true,
            pageSizes: [20, 50, 100, 200],
          }"
        >
          <el-table-column prop="name" label="Name" min-width="120">
          </el-table-column>
          <el-table-column
            prop="membercode"
            label="Menber Code"
            min-width="120"
          >
          </el-table-column>
          <el-table-column prop="projectname" label="Project" min-width="120">
          </el-table-column>
          <el-table-column
            prop="currency"
            label="Currency"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.currency.toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="Type" width="120">
          </el-table-column>
          <el-table-column
            prop="accountnumber"
            label="Account Number"
            min-width="120"
          >
          </el-table-column>
          <el-table-column prop="sortcode" label="Sortcode" min-width="120">
          </el-table-column>
          <el-table-column prop="iban" label="IBAN" min-width="120">
          </el-table-column>
          <el-table-column prop="bic" label="BIC" min-width="120">
          </el-table-column>
          <el-table-column prop="status" label="Status" width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 'active'" size="mini">
                {{ scope.row.status.toUpperCase() }}
              </el-tag>
              <el-tag
                v-if="scope.row.status == 'pending'"
                size="mini"
                type="warning"
              >
                {{ scope.row.status.toUpperCase() }}
              </el-tag>
              <el-tag
                v-if="scope.row.status == 'reject'"
                size="mini"
                type="danger"
              >
                {{ scope.row.status.toUpperCase() }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="paymentuid"
            label="Actions"
            width="100"
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <ViewInfo :uid="scope.row.beneficiary_id" :info="scope.row" v-on:onSuccess="getBeneficiaryPending()"/>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getBeneficiary } from "@/api/beneficiary-monitor";

import ViewInfo from "./components/beneficiary-view.vue";

export default {
  components: {
    ViewInfo,
  },
  data() {
    return {
      memberCode: this.$route.params.membercode || "",
      loading: false,
      tableData: [],
    };
  },
  methods: {
    getBeneficiaryPending() {
      this.tableData = [];
      this.loading = true;
      getBeneficiary("pending").then(({ result, data, message }) => {
        this.loading = false;
        if (result) {
          this.tableData = data;
        }
      });
    },
  },
  mounted() {
    this.getBeneficiaryPending();
  },
};
</script>

<style lang="scss" scoped>
.beneficiary-detail-content {
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 12px;
    margin-bottom: 10px;

    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
}
</style>